import React, { Component } from 'react';
import Icofont from 'react-icofont';
import PropTypes from "prop-types";
import { Accordion, AccordionItem } from "react-sanfona";
import { Link } from "react-scroll";
import ScrollAnimation from 'react-animate-on-scroll';

class FAQ extends Component {
    render() {
        return (
            <React.Fragment>
                <section className="faq ptb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2 text-center">
                                <ScrollAnimation animateIn="fadeInUp">
                                    <div className="section-title">
                                        <h2>{this.props.sectionTitle}</h2>
                                        <p>{this.props.sectionDescription}</p>
                                        <span className="section-title-bg">{this.props.SectionbgTitle}</span>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="faq-content">
                            <div className="row">
                                <div className="col-lg-4">
                                    <Link
                                        activeclass="active"
                                        to="contact"
                                        spy={true}
                                        smooth={true}
                                        offset={-100}
                                        duration={800}
                                        className="nav-link"
                                    >
                                        <div className="content-box color-effect-1">
                                            <h3>{this.props.ContentTitle}</h3>

                                            <div className="box-icon-wrap box-icon-effect-1 box-icon-effect-1a">
                                                <div className="box-icon"><Icofont icon="icofont-share-alt" /></div>
                                            </div>

                                            <p>{this.props.ContentDescription}</p>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-lg-8">
                                    <Accordion
                                        rootTag="div"
                                        className="panel-group"
                                        openNextAccordionItem
                                    >
                                        {this.props.faqData.map(item => {
                                            return (
                                                <AccordionItem
                                                    key={item}
                                                    title={item.title}
                                                    expanded
                                                    expandedClassName=""
                                                    className="panel-title panel panel-default"
                                                    titleTag="a"
                                                    titleClassName=""
                                                >
                                                    <div>
                                                        <div className="panel-body">
                                                            <p>{item.description}</p>
                                                        </div>
                                                    </div>
                                                </AccordionItem>
                                            );
                                        })}
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

//Props Types
FAQ.propTypes = {
    SectionbgTitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    sectionDescription: PropTypes.string,
    ContentLink: PropTypes.string,
    ContentTitle: PropTypes.string,
    ContentDescription: PropTypes.string,
    faqData: PropTypes.array
};

//Default Props
FAQ.defaultProps = {
    SectionbgTitle: "FAQ",
    sectionTitle: "你問我答",
    sectionDescription:
        "",

    ContentTitle: "其他問題",
    ContentDescription: "如有更多問題，歡迎聯絡我們。",
    ContentLink: "/#0",

    faqData: [
        {
            title: "高登新聞部班記者係咪痴線架？",
            description: "無錯係！",
        },
        {
            title: "課完金啲錢去咗邊？",
            description: "養住班青山走犯，同時積極開發全新節目，因為香港真係太悶啦。",
        },
        {
            title: "目標金額係幾多？",
            description: "多多都用得著，愈多人ioin月費計劃就愈有能力做到高質素節目，長遠準備取代電視台，做足24小時節目（真心架！）"
        },
        {
            title: "接唔接廣告？",
            description: <span>有咩留返<span className="span-a" onClick={()=>window.open(`https://wa.me/85252294470`, '_blank')}><b>Whatsapp</b></span>先講，或者<span className="span-a" onClick={()=>window.open(`mailto:marketing@alivemedia.com.hk`)}><b>Email</b></span>同我哋聯絡。</span>,
        },
        {
            title: "高登新聞台係咪真係認真發展？",
            description: "認真思考過，呢個世界，有啲事情，只有「高登」呢個牌頭先做到，咁當然要認真做落去。"
        }
    ]
};

export default FAQ;